import React, { useEffect, useMemo, useState } from "react";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  phoneNumberValidation,
  validURL,
} from "./Validations";
import ExcelIcon from "../Assets/svgs/ExcelIcon";
import TxtIcon from "../Assets/svgs/TxtIcon";
import MarkdownIcon from "../Assets/svgs/MarkdownIcon";
import WordIcon from "../Assets/svgs/WordIcon";
import ModernPdfIcon from "../Assets/svgs/ModernPdfIcon";
import CloseBtnIcon from "../Assets/svgs/CloseBtnIcon";
import DateSelector from "./DateSelector";
import { ALL_CALLING_CODES } from "./Constants";
import {
  getCountryCodeByFullPhone,
} from "./utils";
import CountryPhoneInput from "./CountryPhoneInput";

const AllFormFields = ({
  fieldData,
  showErrorMessage,
  onSubmit,
  submitBtnText,
}) => {
  const [formData, setFormData] = useState(
    Array.isArray(fieldData)
      ? fieldData
          ?.map((field) => ({
            ...field,
            isDisabled: field?.value ? true : false,
          }))
          .sort((a, b) => a?.order - b?.order)
      : []
  );
  const [formError, setFormError] = useState(
    Array.isArray(fieldData) ? fieldData?.map(() => "") : []
  );

  const replaceCountryCode = (value = "", newValue) => {
    for (const code of ALL_CALLING_CODES) {
      if (value?.includes(code)) {
        return value.replace(code, newValue);
      }
    }
    return newValue;
  };

  const validateFiles = (files, maxSize, extensionAllowed = []) => {
    for (let file of files) {
      // const fileExtension = file?.type;
      const fileExtension = file?.name?.split(".").pop().toLowerCase();

      // Check if file extension is allowed
      if (!extensionAllowed.includes(fileExtension)) {
        showErrorMessage(`Invalid file type: ${file.name}!`);
        return false;
      }

      // Check if file size is within limit
      if (file.size > maxSize) {
        showErrorMessage(`File size too large: ${file.name}!`);
        return false;
      }
    }

    return true;
  };

  const handleChange = (e, index) => {
    let { value, type, name } = e?.target;
    if (type == "file") {
      const files = e?.target?.files;
      if (!files.length) return;
      const formItem = formData[index];
      const isValid = validateFiles(
        files,
        formItem?.size * 1024 * 1024,
        formItem?.extensionAllowed
      );
      if (isValid) {
        setFormData((prev) =>
          prev.map((field, fieldIndex) =>
            fieldIndex == index
              ? {
                  ...field,
                  value: files[0],
                }
              : field
          )
        );
      }
      setTimeout(() => {
        e.target.value = "";
      }, 300);
    } else if (type == "number") {
      setFormData((prev) =>
        prev.map((field, fieldIndex) =>
          fieldIndex == index
            ? {
                ...field,
                value: value?.replace(/\D/g, ""),
              }
            : field
        )
      );
    } else if (type == "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      setFormData((prev) =>
        prev.map((field, fieldIndex) =>
          fieldIndex == index
            ? {
                ...field,
                value: value,
              }
            : field
        )
      );
      setFormError((prev) =>
        prev.map((errorField, fieldIndex) =>
          fieldIndex == index
            ? isValid || value.trim() === ""
              ? ""
              : "Please enter valid Email"
            : errorField
        )
      );
    } else if (type == "url") {
      setFormData((prev) =>
        prev.map((field, fieldIndex) =>
          fieldIndex == index
            ? {
                ...field,
                value: value,
              }
            : field
        )
      );
      const isValid = validURL(value);
      if (isValid || value?.trim() === "") {
        setFormError((prev) =>
          prev.map((errorField, fieldIndex) =>
            fieldIndex == index ? "" : errorField
          )
        );
      } else {
        setFormError((prev) =>
          prev.map((errorField, fieldIndex) =>
            fieldIndex == index ? "Please enter valid url" : errorField
          )
        );
      }
    } else if (name === "first_name" || name == "last_name") {
      setFormData((prev) =>
        prev.map((field, fieldIndex) =>
          fieldIndex == index
            ? {
                ...field,
                value: value,
              }
            : field
        )
      );
      const isValid = nameValidation(value);
      if (isValid || value?.trim() === "") {
        setFormError((prev) =>
          prev.map((errorField, fieldIndex) =>
            fieldIndex == index ? "" : errorField
          )
        );
      } else {
        setFormError((prev) =>
          prev.map((errorField, fieldIndex) =>
            fieldIndex == index ? "Please enter valid name" : errorField
          )
        );
      }
    } else {
      setFormData((prev) =>
        prev.map((field, fieldIndex) =>
          fieldIndex == index
            ? {
                ...field,
                value: value,
              }
            : field
        )
      );
    }
  };

  const isInvalidData = useMemo(() => {
    let isHasInvalidData = formData?.some(
      (field) =>
        (field?.type == "phone"
          ? (field?.value ?? "")?.length < 6
          : !field?.value) && field?.required
    );
    const isFormError = formError.some((error) => error);
    return isHasInvalidData || isFormError;
  }, [formData]);

  useEffect(() => {
    const allFields = Array.isArray(fieldData)
      ? fieldData
          ?.map((field) => ({
            ...field,
            isDisabled: field?.value ? true : false,
          }))
          .sort((a, b) => a?.order - b?.order)
      : [];
    setFormData(allFields);
    setFormError(allFields?.map(() => ""));
  }, [JSON.stringify(fieldData)]);

  return (
    <div className="CreateformBoxChat__form__body">
      <div className="formRow formRow__2">
        {formData?.map((field, index) =>
          field?.type == "input" ||
          field?.type == "text" ||
          field?.type == "number" ||
          field?.type == "url" ? (
            <div key={`${index}`} className="formCol">
              <div className="form__Field">
                <label htmlFor="input-field" className="form__label">
                  {field?.name}
                  {field?.required ? (
                    <span style={{ color: "red" }}> * </span>
                  ) : null}
                </label>
                <input
                  type={
                    field?.name == "Email"
                      ? "email"
                      : field?.type == "text" || field?.type == "input"
                      ? "text"
                      : field?.type == "number"
                      ? "number"
                      : field?.type == "url"
                      ? "url"
                      : "text"
                  }
                  maxLength={field?.name == "Email" ? 100 : undefined}
                  name={field?.label}
                  id="input-field"
                  className={`form__input form__input--sm ${
                    field?.isDisabled ? "form__input--disabled" : ""
                  }`}
                  disabled={field?.isDisabled ?? false}
                  value={field?.value ?? ""}
                  onChange={(e) => handleChange(e, index)}
                  placeholder={field?.name}
                />
                {formError[index] && (
                  <div className="form__error">{formError[index]}</div>
                )}
              </div>
            </div>
          ) : field?.type == "upload" ? (
            <div key={`${index}`} className="formCol">
              <div className="form__Field">
                <label htmlFor="uploadFile" className="form__label">
                  {field?.name}
                  {field?.required ? (
                    <span style={{ color: "red" }}> * </span>
                  ) : null}
                </label>
                <div className="form__browsefileBox">
                  <div className="form__browsefile form__browsefile--sm">
                    {field?.value ? (
                      <div className="form__browsefile__value">
                        {field?.value?.type == "text/csv" ||
                        field?.value?.type ==
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                          <ExcelIcon width="20" height="20" />
                        ) : field?.value?.type == "text/plain" ? (
                          <TxtIcon width="20" height="20" />
                        ) : field?.value?.type == "text/markdown" ? (
                          <MarkdownIcon width="20" height="20" />
                        ) : field?.value?.type == "application/msword" ||
                          field?.value?.type ==
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                          <WordIcon width="20" height="20" />
                        ) : (
                          <ModernPdfIcon />
                        )}
                        <div className="form__browsefile__value__detail">
                          <p className="para">{field?.value?.name}</p>
                        </div>
                      </div>
                    ) : null}
                    <input
                      type="file"
                      id={`UploadFile - ${index}`}
                      name={field?.label}
                      className="form__uploadfiled"
                      accept={
                        Array.isArray(field?.extensionAllowed)
                          ? field?.extensionAllowed
                              ?.map((type) => `.${type}`)
                              .join(",")
                          : ""
                      }
                      onChange={(e) => handleChange(e, index)}
                    />
                    {!field?.value ? (
                      <>
                        <label
                          className="btn btn__primary"
                          htmlFor={`UploadFile - ${index}`}
                        >
                          Browse File
                        </label>
                        <input
                          type="text"
                          className="form__input"
                          placeholder="No file chosen"
                          disabled
                        />
                      </>
                    ) : null}
                    {field?.value ? (
                      <span
                        className="form__browsefile__closeBtn"
                        onClick={() =>
                          setFormData((prev) =>
                            prev.map((field, fieldIndex) =>
                              fieldIndex == index
                                ? {
                                    ...field,
                                    value: null,
                                  }
                                : field
                            )
                          )
                        }
                      >
                        <CloseBtnIcon />
                      </span>
                    ) : null}
                  </div>
                </div>

                <p className="form__infoText">
                  <strong>Supported file type:</strong>
                  {Array.isArray(field?.extensionAllowed)
                    ? field?.extensionAllowed
                        ?.map((type) => `.${type}`)
                        .join(",")
                    : ""}
                  &nbsp;
                  <span>
                    <strong>Max file size:</strong> {field?.size}
                    MB
                  </span>
                </p>
                {formError[index] && (
                  <div className="form__error">{formError[index]}</div>
                )}
              </div>
            </div>
          ) : field?.type == "date" ? (
            <div key={`${index}`} className="formCol">
              <div className="form__Field">
                <label htmlFor="input-field" className="form__label">
                  {field?.name}
                  {field?.required ? (
                    <span style={{ color: "red" }}> * </span>
                  ) : null}
                </label>
                <DateSelector
                  name="date"
                  value={field?.value ?? ""}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="DD/MM/YYYY"
                />
                {formError[index] && (
                  <div className="form__error">{formError[index]}</div>
                )}
              </div>
            </div>
          ) : field?.type == "phone" ? (
            <div key={`${index}`} className="formCol">
              <div className="form__Field">
                <label htmlFor="input-field" className="form__label">
                  {field?.name}
                  {field?.required ? (
                    <span style={{ color: "red" }}> * </span>
                  ) : null}
                </label>
                <CountryPhoneInput
                  countryCodeFieldName="countryCallingCode"
                  phoneFieldName="phoneNumber"
                  disabled={field?.isDisabled ?? false}
                  countryCode={getCountryCodeByFullPhone(field?.value)}
                  phoneNumber={replaceCountryCode(field?.value, "")}
                  onCountryChange={({ target: { value } }) => {
                    const phoneNo = replaceCountryCode(field?.value, "");
                    let formatted = phoneNo;
                    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
                    const rawDigits = phoneNo.replace(/\D/g, "");
                    const isValid = phoneNumberValidation(rawDigits, value);
                    setFormError((prev) =>
                      prev.map((errorField, fieldIndex) =>
                        fieldIndex == index
                          ? isValid
                            ? ""
                            : rawDigits.length < minDigits
                            ? `Phone number must be at least ${minDigits} digits long.`
                            : "Please enter a valid phone number"
                          : errorField
                      )
                    );
                    setFormData((prev) =>
                      prev.map((prevField, fieldIndex) =>
                        fieldIndex === index
                          ? {
                              ...prevField,
                              value: `${value}${formatted}`,
                            }
                          : prevField
                      )
                    );
                  }}
                  onPhoneChange={(e) => {
                    handlePhoneNoChange(
                      e,
                      getCountryCodeByFullPhone(field?.value),
                      () => {
                        setFormData((prev) =>
                          prev.map((prevField, fieldIndex) =>
                            fieldIndex === index
                              ? {
                                  ...prevField,
                                  value: `${getCountryCodeByFullPhone(
                                    field?.value
                                  )}${e?.target?.value}`,
                                }
                              : prevField
                          )
                        );
                      },
                      (newError) =>
                        setFormError((prev) =>
                          prev.map((errorField, fieldIndex) =>
                            fieldIndex == index ? newError : errorField
                          )
                        ),
                      () => {},
                      false
                    );
                  }}
                />
                {formError[index] && (
                  <div className="form__error">{formError[index]}</div>
                )}
              </div>
            </div>
          ) : null
        )}
      </div>
      <div className="btn__group">
        <button
          className="btn btn__primary"
          disabled={isInvalidData}
          onClick={() => onSubmit(formData)}
        >
          {submitBtnText ?? "Next"}
        </button>
      </div>
    </div>
  );
};

export default AllFormFields;
